import {IconButton} from "@mui/material";
import {FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import {tokenColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import {useEffect} from "react";

const Tokens = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest("/tokens");

  useEffect(() => {
    list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUserClick = (e, userId) => {
    e.stopPropagation();
    if (userId) {
      navigate(`/user-form`, {state: {id: userId}});
    }
  };

  const handleRowDelete = async (id) => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este token?");
    if (confirmDelete) {
      try {
        await remove(id);
        list();
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
      }
    }
  };

  const columns = [
    ...tokenColumns.filter((col) => col.field !== "email"), //Excluimos user_id para poder ponerle un renderCell personalizado

    {
      field: "email",
      headerName: "Usuario",
      width: 180,
      editable: false,
      renderCell: (params) => (
        <span
          style={{
            color: "primary.main",
            textDecoration: "underline",
            cursor: "pointer"
          }}
          onClick={(e) => handleUserClick(e, params.row.user_id)}
        >
          {params.row.email}
        </span>
      )
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="delete"
          color="secondary"
          onClick={(e) => {
            e.stopPropagation();
            handleRowDelete(params.row.id);
          }}
        >
          <FiTrash2 />
        </IconButton>
      )
    }
  ];

  return (
    <Window title={"Tokens"}>
      {loading ? (
        <div style={{textAlign: "center", padding: "20px"}}>
          <span style={{fontSize: "18px", color: "#666"}}>Cargando...</span>
        </div>
      ) : (
        <ListView columns={columns} data={data?.data} getRowId={(row) => row.id} />
      )}
    </Window>
  );
};

export default Tokens;
